import type { ProspectMatterType } from '@common/enums';
import { Icon } from '@iconify/react';
import { Box } from '@mui/material';

function getMatterTypeIcon(matterType: ProspectMatterType) {
    if (matterType === 'Sale') return 'ph:hand-coins';
    if (matterType === 'Purchase') return 'ph:currency-circle-dollar';
    if (matterType === 'Refinance') return 'ph:arrows-counter-clockwise';
    if (matterType === 'PrivateLender') return 'ph:bank';
    if (matterType === 'TitleTransfer') return 'ph:hand-withdraw';
    if (matterType === 'BareTransfer') return 'ph:hand-withdraw';
    if (matterType === 'BareTransferAndRefinance') return 'ph:arrows-counter-clockwise';
    if (matterType === 'ILA') return 'ph:briefcase';
    if (matterType === 'PurchaseAndSale') return 'ph:handshake';
    if (matterType === 'Transfer') return 'ph:hand-withdraw';
    if (matterType === 'TransferAndRefinance') return 'ph:arrows-counter-clockwise';
    if (matterType === 'TransferOfTitle') return 'ph:hand-withdraw';
    if (matterType === 'SurvivorshipApplication') return 'ph:file-text';
    if (matterType === 'ForProfitIncorporation') return 'ph:buildings';
    if (matterType === 'NotForProfitIncorporation') return 'ph:users-three';
    if (matterType === 'Corporate') return 'ph:buildings';
    if (matterType === 'EstatePlanning') return 'ph:scroll';
    if (matterType === 'EstateAdministration') return 'ph:clipboard-text';
    if (matterType === 'PowerOfAttorney') return 'ph:signature';
    if (matterType === 'Civil') return 'ph:scales';
    if (matterType === 'PersonalInjury') return 'ph:first-aid-kit';
    if (matterType === 'EmploymentLaw') return 'ph:briefcase';
    if (matterType === 'LandlordTenant') return 'ph:house-line';
    if (matterType === 'MotorVehicleAccident') return 'ph:car';
    if (matterType === 'Litigation') return 'ph:gavel';
    if (matterType === 'Family') return 'ph:users-four';
    if (matterType === 'Divorce') return 'ph:users-four';
    if (matterType === 'CohabitationAgreement') return 'ph:heart';
    if (matterType === 'SeparationAgreement') return 'ph:file-text';
    if (matterType === 'ParentingAgreement') return 'ph:baby';
    if (matterType === 'SpousalSupport') return 'ph:hand-coins';
    if (matterType === 'MarriageCohabitation') return 'ph:heart';
    if (matterType === 'FertilityLaw') return 'ph:baby';
    if (matterType === 'MotionToChange') return 'ph:file-text';
    if (matterType === 'SeparationAndDivorce') return 'ph:users-four';
    if (matterType === 'IndependentLegalAdvice') return 'ph:briefcase';
    if (matterType === 'Criminal') return 'ph:gavel';
    if (matterType === 'ImpairedDriving') return 'ph:car';
    if (matterType === 'Assault') return 'ph:hand-fist';
    if (matterType === 'TheftAndFraud') return 'ph:detective';
    if (matterType === 'Immigration') return 'ph:globe-hemisphere-west';
    if (matterType === 'TemporaryStatus') return 'ph:globe-hemisphere-west';
    if (matterType === 'PermanentResidence') return 'ph:globe-hemisphere-west';
    if (matterType === 'Citizenship') return 'ph:globe-hemisphere-west';
    if (matterType === 'GeneralIntake') return 'ph:clipboard-text';
    return 'ph:hand-coins';
}

interface Props {
    matterType: ProspectMatterType;
    width: number;
    color: string;
}

export default function MatterTypeIcon({ matterType, width, color }: Props) {
    return (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color }}>
            <Icon icon={getMatterTypeIcon(matterType)} width={width} />
        </Box>
    );
}
